import React from 'react';
import { reasonText } from './txFetchStatus';

// ── Transaction status banner (TSB-4301) ─────────────────────────────────────
//
// Says plainly when the figures below are incomplete, stale, or missing. Silent
// on the happy path.
//
// role="alert" + aria-live so the warning is announced rather than only seen
// (WCAG 3.3.1). The reference id is shown so a user can quote it to support;
// everything else about the failure stays in the console.

function TransactionStatusBanner({ status, onRetry }) {
  if (status.state === 'ok' || status.state === 'idle') return null;

  const { state, failed, total, loadedAt, reference } = status;

  let tone = 'warn';
  let title;
  let text;

  if (state === 'partial') {
    title = 'Showing partial data';
    text = `${failed} of ${total} sources didn't respond, so the figures below are incomplete and read lower than actual.`;
  } else if (state === 'stale') {
    title = "Couldn't refresh";
    text = loadedAt ? `Showing data from ${loadedAt}.` : 'Showing the last data we loaded.';
  } else {
    tone = 'error';
    title = "Couldn't load transaction data";
    text = reasonText(status.reason);
  }

  return (
    <div className={`v2-banner v2-banner--${tone}`} role="alert" aria-live="polite">
      <div className="v2-banner-body">
        <span className="v2-banner-title">{title}</span>
        <span className="v2-banner-text">{text}</span>
      </div>
      <div className="v2-banner-actions">
        {reference && <span className="v2-banner-ref">Reference: {reference}</span>}
        <button type="button" className="v2-banner-retry" onClick={onRetry}>Try again</button>
      </div>
    </div>
  );
}

export default TransactionStatusBanner;
